import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity } from 'lucide-react';

function timeAgo(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'Less than a minute ago';
  if (mins < 60) return `${mins} minute${mins > 1 ? 's' : ''} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs > 1 ? 's' : ''} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days > 1 ? 's' : ''} ago`;
}

export default function ZohoDashboardActivity({ activities }) {
  return (
    <Card data-testid="activity-feed-section">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold">Activity Feed</CardTitle>
      </CardHeader>
      <CardContent>
        {activities.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Activity className="h-8 w-8 mx-auto mb-2 opacity-20" />
            <p className="text-sm">No activity yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {activities.map(a => (
              <div key={a.id} className="flex items-start gap-3" data-testid={`activity-${a.id}`}>
                <div className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${a.status === 'success' ? 'bg-primary' : 'bg-destructive'}`} />
                <div className="min-w-0">
                  <p className="text-sm leading-snug">{a.message}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{timeAgo(a.timestamp)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
